import { Insales, InsalesService } from '../api';

interface InsalesProviderResource {
  getList: (
    resource: string,
    params: any
  ) => Promise<{ data: Insales[]; total: number }>;
  create: (resource: string, params: any) => Promise<{ data: Insales }>;
  getOne: (resource: string, params: any) => Promise<{ data: Insales }>;
  update: (resource: string, params: any) => Promise<{ data: Insales }>;
  getMany: (resource: string, params: any) => Promise<{ data: Insales[] }>;
  getManyReference: (
    resource: string,
    params: any
  ) => Promise<{ data: Insales[] }>;
}

export const insalesProvider: InsalesProviderResource = {
  getList: async (resource, params) => {
    console.log('getList');
    console.log(params);
    const { items } = await InsalesService.getInsales();
    console.log(items);
    if (!items) {
      return {
        data: [],
        total: 0,
      };
    }
    return {
      data: items,
      total: items.length,
    };
  },
  create: async (resource, params) => {
    console.log(params);
    const {
      data: { name, url, user, password, is_enabled, model_id, site_url },
    } = params;
    const insales = await InsalesService.addInsales({
      name,
      url,
      user,
      password,
      is_enabled,
      model_id,
      site_url,
    });
    return { data: insales };
  },
  getOne: async (resource, params) => {
    const insales = await InsalesService.getInsaleById(params.id);
    return { data: insales };
  },
  update: async (resource, params) => {
    console.log(params);
    const {
      data: { name, url, user, password, is_enabled, model_id, site_url },
    } = params;
    const model = await InsalesService.updateInsaleById(params.id, {
      name,
      url,
      user,
      password,
      is_enabled,
      model_id,
      site_url,
    });
    return { data: model };
  },
  getMany: async (resource, params) => {
    console.log(resource);
    console.log(params);
    const ids = params.ids;
    console.log(ids);
    const data: Insales[] = [];
    for (const id of ids) {
      const model = await InsalesService.getInsaleById(id);
      data.push(model);
    }
    return { data: data };
  },
  getManyReference: async (resource, params) => {
    console.log(resource);
    console.log(params);
    return { data: [] };
  },
};
